const contestResultsI18nEn = {
	"results-overview": "Overview",
	"results-members": "Members",
	"contest-submissions": "Submissions throughout the contest",
	day: "Day",
	"the-day": "Day",
	submissions: "Submissions",
	members: "Members",
	"top-3": "Top 3",
	"no-of-submissions": "No. of submissions",
	today: "Today",
	of: "of",
	score: "Score",
	date: "Date",
	selectMember: "Select member",
	selectDay: "Select day",
	totalPoints: "Total points",
	average: "Average",
	rank: "Rank",
	pointsPerDay: "Points per day",
	scorePerCategory: "Score per category",
	viewSubmissionsPerDay: "View submissions per day",
	close: "Close",
	save: "Save",
	dailySubmissionsPopup: {
		title: "Submissions per day",
		load: "Load",
		date: "Date",
		noData: "No data",
		criteriaTitle: "Criteria",
		answer: "Answer",
		noSubmissions: "No submissions for this day",
		selectDate: "Select date",
		points: "Points",
		lastUpdated: "Last updated",
		previousDays: "Previous days",
		nextDays: "Next days",
		editAnswer: "Edit answer",
		cancel: "Cancel",
		addSubmission: "Add submission",
	},
	"no-results": "No results",
	failedToSave: "Failed to save",
	back: "Back",
	showResults: "Show results",
	exportToExcel: "Export",
	exportResults: "Export Results",
	exportDateRange: "Date Range",
	exportMembers: "Members",
	export: "Export",
	newExport: "New Export",
	noExports: "No exports yet",
	noExportsTitle: "No exports yet",
	noExportsDescription: "Create a new export to download contest results",
	createExport: "Create Export",
	exportByMembers: "Specific Members",
	selectSpecificMembers: "Select specific members",
	specificMembers: "Specific Members",
	exportMaxDays: "Date range cannot exceed 31 days",
	maxMembersExceeded: "Maximum 250 members per export",
	exportPending: "Pending",
	exportProcessing: "Processing...",
	exportCompleted: "Completed",
	exportFailed: "Export Failed",
	existingExportFound: "An export with the same data already exists",
	exportCreated: "Export requested",
	downloadExport: "Download",
	downloadExcel: "Download Excel",
	downloadCsv: "Download CSV",
	downloadJson: "Download JSON",
	exportExpiresIn: "Expires in {{time}}",
	exportExpired: "Expired",
	exportSuccess: "Export completed successfully",
	exportError: "Failed to export results",
	summary: "Summary",
	detailedBreakdown: "Detailed Breakdown",
	member: "Member",
	criterion: "Criterion",
	total: "Total",
	totalSubmissions: "Total Submissions",
	contestTotal: "Contest Total",
	allMembersSelected: "All members selected",
	membersSelected: "{{count}} members selected",
	exportGroup: "Group",
	allGroups: "All groups",
	exportByGroup: "By group",
	exportAllMembers: "All members",
	allGroupMembers: "All group members",
	groupRequired: "Please select a group",
	cancel: "Cancel",
	delete: "Delete",
	deleteExportTitle: "Delete export",
	deleteExportDescription: "Are you sure you want to delete this export?",
};

export default contestResultsI18nEn;
